(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4667],{

/***/ 7763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guia-de-compras",
      function () {
        return __webpack_require__(1835);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(1688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6008);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




function OfferBanner(param) {
    var _isOnHome = param.isOnHome, isOnHome = _isOnHome === void 0 ? false : _isOnHome, _phrase = param.phrase, phrase = _phrase === void 0 ? "Siga o Canal do CT no WhatsApp" : _phrase, _link = param.link, link = _link === void 0 ? "https://canalte.ch/canaltech-no-whatsapp-site" : _link;
    var textBanner = phrase;
    var Container = function(param) {
        var children = param.children;
        if (isOnHome) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative flex w-full flex-col flex-wrap content-center justify-center bg-mglGray50 pt-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-6 max-[500px]:pr-12",
                children: children
            })
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex w-full items-center justify-center gap-2 rounded bg-[#25D366] p-4", !isOnHome && "mb-8"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: " text-sm leading-tight text-mglGray900 tablet:text-base",
                    children: textBanner
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: link,
                    target: "_blank",
                    className: "canal-ct-wpp flex appearance-none items-center gap-1 rounded-3xl border-0 bg-mglGray900 px-4 py-2 text-xs text-mglGray50 outline-none transition-opacity hover:opacity-80 focus:opacity-80",
                    title: textBanner,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            icon: "mdi:whatsapp"
                        }),
                        " Entrar"
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 4934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5935);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6008);







function Accordion(param) {
    var items = param.items, openItem = param.openItem, blueTheme = param.blueTheme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(openItem || ""), selected = ref[0], setSelected = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("mx-4 my-0 list-none rounded bg-transparent px-8 tablet:mx-auto tablet:my-auto  tablet:mt-4", blueTheme && "  bg-white"),
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionItem, {
                content: item.content,
                isOpen: item.title === selected,
                title: item.title,
                setSelected: setSelected,
                blueTheme: blueTheme
            }, item.title);
        })
    });
}
function AccordionItem(param) {
    var isOpen = param.isOpen, title = param.title, content = param.content, setSelected = param.setSelected, blueTheme = param.blueTheme;
    var isOpenProps = {
        Container: "pb-6",
        Button: "isOpenAccordion mb-4 [&>svg]:rotate-180"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("border-0 border-b-[0.5px] border-solid border-b-mglGray200 bg-mglGray50 py-8", blueTheme && "  bg-white", isOpen && isOpenProps.Container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex w-full appearance-none items-center justify-between gap-8 border-none bg-mglGray50 [&>h2]:w-full [&>h2]:text-left [&>h2]:text-lg [&>svg]:transition-all [&>svg]:duration-300 [&>svg]:ease-ease", isOpen && isOpenProps.Button, blueTheme && "bg-white", "transition-all duration-[600ms]"),
                onClick: function() {
                    return setSelected(isOpen ? "" : title);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: title
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        icon: "mdi:chevron-down",
                        width: 18,
                        height: 18,
                        color: blueTheme ? _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglBlue.mglBlue400 */ .Db.mglBlue400 : _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray900 */ .Ce.mglGray900
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Internals_NewsContent_styles__WEBPACK_IMPORTED_MODULE_3__/* .DivContentNews */ ._7, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("m-0 h-auto max-h-0 w-full overflow-hidden text-mglGray900 opacity-0 transition-all duration-[600ms] first:mt-2", isOpen && "max-h-screen opacity-100"),
                children: typeof content === "object" ? content : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(content)
            })
        ]
    });
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 1835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ GuiaDeCompras; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Layout/Image/index.tsx + 1 modules
var Image = __webpack_require__(2153);
// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
// EXTERNAL MODULE: ./src/components/Layout/Accordion/index.tsx
var Accordion = __webpack_require__(4934);
// EXTERNAL MODULE: ./src/components/Layout/ProsAndCons/index.tsx
var ProsAndCons = __webpack_require__(4879);
// EXTERNAL MODULE: ./src/components/Layout/IFrameYoutube/index.tsx
var IFrameYoutube = __webpack_require__(3251);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
// EXTERNAL MODULE: ./src/components/Internals/OfferBanner/index.tsx
var OfferBanner = __webpack_require__(7586);
;// CONCATENATED MODULE: ./src/components/Internals/CollapsedText/index.tsx


var CollapsedText = function(param) {
    var pageDescription = param.pageDescription;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var charactersLimit = 362;
    var description = typeof pageDescription === "string" ? pageDescription : "";
    var toggleSeeMore = function() {
        setIsExpanded(!isExpanded);
    };
    var displayedText = isExpanded ? description : description.slice(0, charactersLimit) + "...";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-4 desktop:mx-0 desktop:mb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col text-mglGray800",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: displayedText
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: toggleSeeMore,
                className: "mt-2 flex items-center border-none bg-transparent text-mglBlue400",
                children: [
                    !isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        className: "mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "currentColor",
                            d: "M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        className: "mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "currentColor",
                            d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6l-6 6z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: !isExpanded ? "Mais informa\xe7\xf5es" : "Menos informa\xe7\xf5es"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Internals_CollapsedText = (CollapsedText);

// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/pages/guia-de-compras/index.tsx

















var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var __N_SSP = true;
function GuiaDeCompras(param) {
    var guiaData = param.guiaData;
    var endpointImages = publicRuntimeConfig.NEXT_PUBLIC_URL_BUCKET;
    var ref = (0,react.useState)(null), isActive = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), isProgrammaticScroll = ref1[0], setIsProgrammaticScroll = ref1[1];
    var handleScroll = function() {
        if (isProgrammaticScroll) {
            return;
        }
        var categoryTitle = document.querySelectorAll("h2[id]");
        var activeSection = "";
        categoryTitle.forEach(function(h2) {
            var rect = h2.getBoundingClientRect();
            if (rect.top <= 500) {
                activeSection = h2.id;
            }
        });
        setActive(activeSection);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        isProgrammaticScroll
    ]);
    var toggleActive = function(index) {
        setActive(index);
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isTabletOrMobile = ref2[0];
    var imagensLinks = {
        amazon: {
            title: "Amazon",
            url: "https://t.ctcdn.com.br/LykfprPimFYYhJwlIH6oGWKDy5I=/i925931.png",
            blurhash: "LpO|Lgoex]t7_Nj]oKj?Rjj[RPay"
        },
        magalu: {
            title: "Magalu",
            url: "https://t.ctcdn.com.br/iDAAZZNFyTDn0OGcIbDNmqJVbLE=/i925929.png",
            blurhash: "L,OW:CsoxpkW_NW=n+oJMvbHNKf6"
        },
        mercado_livre: {
            title: "Mercado Livre",
            url: "https://t.ctcdn.com.br/h_qiNRYZDHIHDWb8OwUBC4FJLO8=/i925933.png",
            blurhash: "LzP6]hn#t6og~qofayj[IUf,Rkj?"
        }
    };
    var responsiveClass = "first:[&>figure]:block last:[&>figure]:hidden tablet:first:[&>figure]:hidden tablet:last:[&>figure]:block";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Guia de Compras"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(responsiveClass, "w-full p-4 desktop:p-8 [&_figure_div_img]:rounded-xl"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "".concat(endpointImages).concat(guiaData.banner.imagem_mobile),
                                    blurhash: "LAAv9C}*ERIcoYxXoKS20B9$-P-i"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "".concat(endpointImages).concat(guiaData.banner.imagem_desktop),
                                    blurhash: "LE9Z~NvxMa?dSvskwHT14:R;b{M_",
                                    height: 347
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mx-auto my-0 block max-w-[1000px] items-center pb-[51px] phone:pb-0 extraLargeDesktop:max-w-[calc(1000px+100vw-1360px)] [@media_only_screen_and_(min-width:1960px)]:max-w-[1600px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-4 desktop:mx-0 desktop:mb-8 [&>div]:border-[1px] [&>div]:border-solid [&>div]:border-mglGreen500 [&>div]:bg-white [&_.canal-ct-wpp]:transition-all [&_.canal-ct-wpp]:duration-300 [&_.canal-ct-wpp]:ease-ease hover:[&_.canal-ct-wpp]:bg-mglGreen500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBanner/* default */.Z, {
                                        phrase: "\uD83D\uDED2 Entre no nosso canal verificado de ofertas no WhatsApp ✅",
                                        link: "https://canalte.ch/canalofertas"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Internals_CollapsedText, {
                                    pageDescription: guiaData.descricaoPagina
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-1 grid-rows-1 gap-0 px-4 desktop:grid-cols-[minmax(0,1fr)_320px] desktop:gap-4 desktop:px-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: guiaData.itens.categorias.map(function(categoria) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "gap-4",
                                                    id: categoria.titulo.replaceAll(" ", "_"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "my-6 mt-[3rem] text-lg font-semibold text-mglGray800 desktop:text-3xl",
                                                            id: categoria.titulo.replaceAll(" ", "_"),
                                                            children: categoria.titulo
                                                        }),
                                                        categoria.produtos.map(function(produto) {
                                                            var availableLinks = Object.entries(produto.links || {}).filter(function(param) {
                                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                                                return Boolean(value);
                                                            });
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mb-4 rounded-md border-[0.5px] border-solid border-mglGray200 bg-white p-4 pb-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "mb-4 grid grid-cols-[111px_1fr] grid-rows-1 gap-4 desktop:grid-cols-[184px_1fr] desktop:grid-rows-[3.75rem_1fr] desktop:gap-4",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "relative row-span-1 flex max-h-[111px] max-w-[111px] rounded-lg border-[0.5px] border-solid border-mglGray100 p-2 desktop:row-span-2 desktop:max-h-[184px] desktop:max-w-[184px]",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                                    src: "".concat(endpointImages).concat(produto.imagem),
                                                                                    width: isTabletOrMobile ? 95 : 168,
                                                                                    height: isTabletOrMobile ? 95 : 168,
                                                                                    objectFit: "object-contain"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "relative col-start-2 col-end-2 flex w-full min-w-0 flex-col justify-center",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "text-sm text-mglGray800 desktop:text-base",
                                                                                        children: produto.titulo_bloco
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                        className: "overflow-hidden truncate text-ellipsis text-lg font-semibold text-mglGray800 desktop:text-2xl",
                                                                                        title: produto.nome,
                                                                                        children: produto.nome
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            availableLinks.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col-span-2 row-span-1 flex w-full flex-col gap-4 desktop:col-span-1 desktop:flex-row",
                                                                                children: availableLinks.map(function(param) {
                                                                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], link = _param[1];
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex w-full flex-row items-center justify-center gap-4 rounded-md bg-mglGray100 p-4 desktop:flex-col",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                                                src: imagensLinks[key].url,
                                                                                                blurhash: imagensLinks[key].blurhash,
                                                                                                width: 100,
                                                                                                height: 24,
                                                                                                alt: imagensLinks[key].title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                                                                title: "Ver pre\xe7o",
                                                                                                texto: "Ver pre\xe7o",
                                                                                                chipSize: "medium",
                                                                                                color: "white",
                                                                                                hover: "black",
                                                                                                backgroundColor: "green",
                                                                                                link: link,
                                                                                                className: "",
                                                                                                rel: "sponsored",
                                                                                                target: "_blank"
                                                                                            })
                                                                                        ]
                                                                                    }, key);
                                                                                })
                                                                            }) : null
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (0,className/* default */.Z)("mx-[-1rem] ", "[&>ul]:mx-0 ", "[&>ul_li]:rounded-md [&>ul_li]:py-0 ", "[&>ul_li_button]:mb-0 [&>ul_li_button]:gap-2 [&>ul_li_button]:rounded-b-md [&>ul_li_button]:bg-mglGray100 [&>ul_li_button]:px-4 [&>ul_li_button]:py-4 [&>ul_li_button]:text-mglGray800 ", "[&>ul_li_button_h2]:text-sm [&>ul_li_button_h2]:desktop:text-base ", "[&.isOpenAccordion>ul_li_button]:rounded-b-none "),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                                                            items: [
                                                                                {
                                                                                    title: "An\xe1lise do Canaltech",
                                                                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionComponent, {
                                                                                        produto: produto
                                                                                    })
                                                                                }
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, produto.id);
                                                        })
                                                    ]
                                                }, categoria.titulo);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "z-[2] order-first h-full w-full self-start desktop:order-last desktop:w-[320px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "sticky top-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "mb-6 mt-[4rem] text-lg font-semibold text-mglGray800",
                                                        children: "\xcdndice"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "mb-4 flex w-full list-none flex-col rounded-md border-0 border-l-2 border-solid border-mglGray200 bg-black/5 bg-white py-4 desktop:w-[320px]",
                                                        children: guiaData.itens.categorias.map(function(categoria) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "mobile-menu-item menu-item-has-children relative -ml-[2px] flex py-2" + (isActive === categoria.titulo.replaceAll(" ", "_") ? " sub-menu-open border-0 border-l-2 border-solid border-mglBlue400" : ""),
                                                                onClick: function(e) {
                                                                    e.preventDefault();
                                                                    setIsProgrammaticScroll(true);
                                                                    toggleActive(categoria.titulo.replaceAll(" ", "_"));
                                                                    document.getElementById(categoria.titulo.replaceAll(" ", "_")).scrollIntoView({
                                                                        behavior: "smooth"
                                                                    });
                                                                    setTimeout(function() {
                                                                        setIsProgrammaticScroll(false);
                                                                    }, 500);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#".concat(categoria.titulo.replaceAll(" ", "_")),
                                                                    className: "w-full pl-2 text-mglBlue400 visited:text-mglBlue600",
                                                                    children: categoria.titulo
                                                                })
                                                            }, categoria.titulo);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function AccordionComponent(param) {
    var produto = param.produto;
    var endpointImages = publicRuntimeConfig.NEXT_PUBLIC_URL_BUCKET;
    var extractYouTubeVideoID = function(url) {
        var regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        var match = url.match(regex);
        return match ? match[1] : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,className/* default */.Z)("relative rounded-b-md bg-white p-4", "[&_.pros-cons-section]:flex-col desktop:[&_.pros-cons-section]:flex-row", "[&_.pros-cons]:bg-mglGray100", "[&_.pros-cons-div-title]:rounded-t-sm [&_.pros-cons-div-title]:bg-mglGray200", "[&_.pros-cons_ul]:rounded-b-md [&_.pros-cons_ul]:bg-white", "[&_.pros-cons_ul.list-none]:bg-mglGray100", "[&_.divIframeYt]:mb-0", "[&_>div>div>button.cursor-pointer]:bg-transparent [&_>div>div>button.cursor-pointer]:p-0"),
        children: [
            produto.componente_tipo === "AnaliseTexto" && produto.componente_conteudo.imagem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-0 mb-6 mt-0 w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: endpointImages + produto.componente_conteudo.imagem,
                    className: "w-full rounded-md"
                })
            }) : null,
            produto.componente_tipo === "AnaliseVideo" && produto.componente_conteudo.youtube ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameYoutube/* default */.Z, {
                    videoId: extractYouTubeVideoID(produto.componente_conteudo.youtube),
                    videoTitle: ""
                })
            }) : null,
            produto.componente_conteudo.pros.length > 0 && produto.componente_conteudo.contras.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProsAndCons/* default */.Z, {
                pros: produto.componente_conteudo.pros,
                cons: produto.componente_conteudo.contras
            }) : null,
            produto.componente_conteudo.link_analise ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: produto.componente_conteudo.link_analise,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "flex h-7 items-center text-mglBlue400 underline visited:text-mglBlue600",
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "mdi:arrow-right",
                            color: "#0086FF",
                            height: 24,
                            width: 24,
                            className: "rounded-full border border-mglGray200"
                        }),
                        "Leia a mat\xe9ria completa"
                    ]
                })
            }) : null
        ]
    });
}


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 3250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 1688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3250);
} else {}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,9774,2888,179], function() { return __webpack_exec__(7763); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);